// filepath: apps/web/src/features/admin/templates/export-import/ImportButton.tsx
//
// FR-UI-ADM-13 AC-2 / AC-5 — page-level Import button. Opens
// the ImportDialog (focus-trapped modal). The button carries the
// FR-TPL-4 tooltip explaining the install-time customization-
// preservation semantics — the import flow does NOT invoke
// FR-TPL-4's installer logic (per Q3 scoping — the import
// endpoint does not preserve customizations; that is an
// install-side concept). The tooltip is documentation-level only.
//
// Q1 SCOPE: clicking this button opens a dialog that contains a
// file picker + an inline notice "Use the operator console to
// import templates". The Submit import button is rendered
// DISABLED. The SPA does NOT POST to /admin/templates/import.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

interface ImportButtonProps {
  onClick: () => void;
}

export function ImportButton({
  onClick,
}: ImportButtonProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded bg-secondary px-4 py-2 text-sm font-medium text-secondary-foreground hover:bg-secondary/90"
      data-testid="template-bundle-import-button"
      title={t(
        "admin.templates.export_import.tooltip.replaces_preserves_customizations",
      )}
      aria-label={t(
        "admin.templates.export_import.tooltip.replaces_preserves_customizations",
      )}
      style={{ minHeight: "48px", minWidth: "48px" }}
    >
      {t("admin.templates.export_import.action.import")}
    </button>
  );
}
